import API from './index';
import { mapContent } from 'store/system/reducer';

const api = {
    getAllComments(id) {
        return API.authAPI({
            url: `/comment/getAllByAppId?appId=${id}`,
            method: 'GET',
            params: {},
        });
    },
    getComment(id) {
        return API.authAPI({
            url: `/comment/getById?id=${id}`,
            method: 'GET',
            params: {},
        });
    },
    createComment(data) {
        return API.authAPI({
            url: `/comment/create`,
            method: 'POST',
            data,
        });
    },
    updateComment(data) {
        return API.authAPI({
            url: `/comment/update/${data?.id}`,
            method: 'POST',
            data,
        });
    },
    removeComment(data) {
        return API.authAPI({
            url: `/comment/removeById/${data}`,
            method: 'POST',
            data: {},
        });
    },
    updateCommentToPending(formId) {
        return API.authAPI({
            url: `/comment/updateCommentToPending/${formId}`,
            method: 'POST',
            data: {},
        });
    },
    getChangeLogById(id) {
        return API.authAPI({
            url: `/comment/getChangeLogById?id=${id}`,
            method: 'GET',
            param: {},
        });
    },
    exportSummary(appId) {
        return API.authAPI({
            url: `/comment/export-summary/${appId}`,
            method: 'POST',
            data: {},
            responseType: 'blob',
        }).then((resp) => {
            mapContent(resp);
        });
    },
    commentStatusCheck(data) {
        return API.authAPI({
            url: `/comment/statusCheck/${data?.formId}`,
            method: 'POST',
            data: { ...data?.params },
        });
    },
};

export default api;
